import { createFileRoute } from '@tanstack/react-router';

import { VulnerabilityWorkspacePage } from '@/features/vulnerabilities/pages/VulnerabilityWorkspacePage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/vulnerabilities/workspace')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.vulnerabilityWorkspace'),
  }),
  component: VulnerabilityWorkspacePage,
});
